import { useState } from "react";
import { siteName, navItems, tickerItems } from "@/mocks/home";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-300">
      {/* utility strip */}
      <div className="border-b border-background-200">
        <div className="mx-auto max-w-[1180px] px-4 md:px-6 h-9 flex items-center justify-between text-xs text-foreground-600">
          <span className="flex items-center gap-2">
            <i className="ri-calendar-line text-[13px]" aria-hidden="true"></i>
            <span>2026 年 10 月 10 日 · 星期五</span>
          </span>
          <span className="hidden sm:flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-flashlight-fill text-primary-500 text-[13px]" aria-hidden="true"></i>
              今日已更新 38 条爆料
            </span>
            <span className="whitespace-nowrap text-foreground-500">理性吃瓜 · 待核实内容已标注</span>
          </span>
        </div>
      </div>

      {/* main bar */}
      <div className="mx-auto max-w-[1180px] px-4 md:px-6 h-16 flex items-center gap-4">
        <a href="#top" className="flex items-center gap-2.5 shrink-0 group">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
            51
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            {siteName}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1 ml-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 text-sm font-label text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2 ml-auto">
          <div className="flex items-center gap-2 h-9 px-3 rounded-md bg-background-100 border border-background-300 w-[230px]">
            <i className="ri-search-line text-foreground-500 text-sm" aria-hidden="true"></i>
            <input
              type="text"
              placeholder="搜索爆料 / 人物 / 事件"
              className="bg-transparent outline-none text-sm text-foreground-800 placeholder:text-foreground-400 w-full"
            />
          </div>
          <a
            href="#today"
            className="h-9 px-4 rounded-md bg-secondary-500 text-background-50 text-sm font-label flex items-center gap-1.5 hover:bg-secondary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-notification-3-line" aria-hidden="true"></i>
            爆料提醒
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden ml-auto w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-800"
          aria-label="打开菜单"
        >
          <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} aria-hidden="true"></i>
        </button>
      </div>

      {menuOpen && (
        <nav className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="grid grid-cols-2 gap-1.5">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-800 bg-background-100 rounded-md"
              >
                {item.label}
              </a>
            ))}
          </div>
        </nav>
      )}

      {/* 24h hot ticker */}
      <div className="bg-foreground-950 text-background-50">
        <div className="mx-auto max-w-[1180px] px-4 md:px-6 h-10 flex items-center gap-3 overflow-hidden">
          <span className="shrink-0 flex items-center gap-1.5 text-xs font-label text-accent-400">
            <i className="ri-fire-fill" aria-hidden="true"></i>
            24H 热榜
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="ticker-track flex w-max items-center gap-8">
              {[...tickerItems, ...tickerItems].map((item, idx) => (
                <span key={idx} className="flex items-center gap-2 text-xs text-background-100/90 whitespace-nowrap">
                  <span className="px-1.5 py-0.5 rounded-sm bg-primary-500/90 text-background-50 text-[10px] leading-none">
                    {item.label}
                  </span>
                  {item.text}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}